import AsyncGenerator from "./AsyncGenerator";
export default function _wrapAsyncGenerator(fn) {
  return function () {
    return new AsyncGenerator(fn.apply(this, arguments));
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@luma.gl/addons/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator.js
// module id = 500
// module chunks = 0